import Base64 from 'crypto-js/enc-base64'
import Utf8 from 'crypto-js/enc-utf8'
import AES from 'crypto-js/aes'
import Pkcs7 from 'crypto-js/pad-pkcs7'
import CryptoJSCore from 'crypto-js/core'
import Cookie from '@/utils/cookie'

import wx from './wx'

export const FALLBACK_KEY = {
    fuzz_key: null,
    OPEN_CODE: 506,
    CLOSE_CODE: 507,
    getKey () {
        try {
            const fuzz_key = Cookie.getItem('fuzz_key')
            if (fuzz_key) {
                FALLBACK_KEY.fuzz_key = JSON.parse(fuzz_key)
                return FALLBACK_KEY.fuzz_key

            }
        } catch (err) {
            console.error(err)
        }
        return null
    },
    resetKey () {
        Cookie.setItem('fuzz_key', '')
        FALLBACK_KEY.fuzz_key = null
    },
    setKey (key) {
        if (key) {
            const [ encryptKey, iv ] = key.split(';')
            FALLBACK_KEY.fuzz_key = {
                encryptKey,
                iv,
                version: 0
            }
            Cookie.setItem('fuzz_key', JSON.stringify(FALLBACK_KEY.fuzz_key))
            console.log('FALLBACK_KEY', FALLBACK_KEY.fuzz_key)
        }
    }
}

const content_type = 'application/rptkfuzz';

const extraKey = "a41fe1d992154ddb"

const { errorLog } = require('@/utils/log')

const getLatestUserKey = () => {
    const fallback_key = FALLBACK_KEY.getKey()
    return Promise.resolve(fallback_key)
}

const encode = (orig_content_type, data, encryptKey, iv) => {
    let data_s;
    let buf = new Uint8Array();
    if (typeof data === 'object' && data instanceof ArrayBuffer) {
        data_s = String.fromCharCode(new Uint8Array(buf));
    } else if (typeof data === 'object') {
        data_s = JSON.stringify(data);
    } else if (typeof data === 'string') {
        data_s = data
    } else {
        data_s = ''
    }
    return encrypt(orig_content_type, encryptKey, iv) + '\n' + encrypt(data_s, encryptKey, iv)
};


const encrypt = (plainText, key, iv) => {
    key = Base64.parse(key)
    key = key.concat(Utf8.parse(extraKey))
    iv = Utf8.parse(iv)
    const textHex = Utf8.parse(plainText)
    const cipherText = AES.encrypt(
        textHex, key, {
        "iv": iv,
        "mode": CryptoJSCore.mode.CBC,
        "padding": Pkcs7
    });
    return cipherText.toString()
}

const decrypt = (cipherText, key, iv) => {
    try {
        key = Base64.parse(key);
        key = key.concat(Utf8.parse(extraKey))
        iv = Utf8.parse(iv)
        const plainText = AES.decrypt(
            cipherText, key, {
            "iv": iv,
            "mode": CryptoJSCore.mode.CBC,
            "padding": Pkcs7
        })
        return Utf8.stringify(plainText)
    } catch (err) {
        console.error(err)
    }
}

const decode = (resp, encryptKey, iv) => {
    let buf = new Uint8Array();
    let raws = resp['data'].split('\n');
    let content_type = decrypt(raws[0], encryptKey, iv);
    buf = decrypt(raws[1], encryptKey, iv)
    if (content_type.includes('application/json')) {
        resp['data'] = JSON.parse(buf);
    } else {
        resp['data'] = buf;
    }
    if (resp['header']) {
        resp['header']['Content-Type'] = content_type
    }
    return resp
};

export const request = async (obj) => {

    if (typeof obj !== 'object') {
        return wx.request(obj)
    }

    if (obj['fuzz'] !== true) {
        return wx.request(obj)
    }

    const { encryptKey = '', iv = '', version = 1 } = await getLatestUserKey() || {}

    // fuzz version
    if (typeof obj['header'] === 'object') {
        obj['header']['WX-KEY-VERSION'] = version
    } else {
        obj['header'] = {};
        obj['header']['WX-KEY-VERSION'] = version
    }

    // encode request
    if (obj['method'] === 'POST' || obj['method'] === 'PUT' || obj['method'] === 'DELETE') {
        let orig_content_type = obj['header']['content-type'] || 'application/json';
        obj['header']['content-type'] = content_type;
        obj['data'] = encode(orig_content_type, obj['data'], encryptKey, iv)
    }

    // decode response
    if (typeof obj['success'] === 'function') {
        const cb = obj['success'];
        obj['success'] = (resp) => {
            try {
                let resp_data = resp
                if (resp.statusCode === 401) {
                } else if (resp.statusCode === 200 || resp.statusCode === 422) {
                    resp_data = decode(resp, encryptKey, iv)
                }
                cb(resp_data)
            } catch (err) {
                const err_msg = `wxafuzz response handler error: ${err}; other: ${JSON.stringify(obj)}`
                console.error('fuzz error', err_msg)
            }
        }
    }

    return wx.request(obj)
}
